function setupPagination() {
    // Get the data we exposed from the model
    const pagination = window.paginationData;
    const container = document.getElementById("paging-control");
    const rangeDisplay = document.getElementById("pagination-range");

    if (!container || !pagination || pagination.totalPages <= 1) return;

    function getPageUrl(pageNum) {
        return pagination.pageUrlTemplate.replace('Page={page}', 'Page=' + pageNum);
    }

    // Update the "Showing X-Y of Z" text
    function updateRangeText() {
        const from = ((pagination.currentPage - 1) * pagination.pageSize) + 1;
        const to = Math.min(pagination.currentPage * pagination.pageSize, pagination.totalItems);
        rangeDisplay.innerHTML =
            `<bdi>${from} - ${to}</bdi> <bdi>${pagination.ofText}</bdi> ` +
            `<bdi>${pagination.totalItems}</bdi> <bdi>${pagination.recordsText}</bdi>`;
    }

    // Determine how many buttons to show based on screen width
    function getMaxButtons() {
        const width = window.innerWidth;
        if (width < 576) return 5;  // Mobile
        if (width < 992) return 7;  // Tablet
        return 9;                   // Desktop
    }

    // Build the pagination controls
    function buildPagination() {
        container.innerHTML = '';
        const maxButtons = getMaxButtons();
        const { currentPage, totalPages } = pagination;

        // Create Previous button
        const prevBtn = document.createElement('a');
        prevBtn.className = 'prev page-number' + (currentPage === 1 ? ' disabled' : '');
        prevBtn.href = currentPage > 1 ? getPageUrl(currentPage - 1) : "#";
        prevBtn.innerHTML = '<i class="ci-pazar-small ci-caret-left"></i>';
        prevBtn.setAttribute('page-no', currentPage > 1 ? currentPage - 1 : 0);
        container.appendChild(prevBtn);

        // Always show first page
        createPageButton(1);

        // Calculate window around current page
        const halfWindow = Math.floor((maxButtons - 3) / 2); // -3 for first, last, and current
        let start = Math.max(2, currentPage - halfWindow);
        let end = Math.min(totalPages - 1, currentPage + halfWindow);

        // Adjust if we're near the start or end
        if (currentPage <= halfWindow + 1) {
            end = Math.min(maxButtons - 1, totalPages - 1);
        }
        if (currentPage >= totalPages - halfWindow) {
            start = Math.max(2, totalPages - maxButtons + 2);
        }

        // Add left ellipsis if needed
        if (start > 2) {
            container.appendChild(createEllipsis());
        }

        // Add pages in the calculated window
        for (let i = start; i <= end; i++) {
            createPageButton(i);
        }

        // Add right ellipsis if needed
        if (end < totalPages - 1) {
            container.appendChild(createEllipsis());
        }

        // Always show last page if different from first
        if (totalPages > 1) {
            createPageButton(totalPages);
        }

        // Create Next button
        const nextBtn = document.createElement('a');
        nextBtn.className = 'next page-number' + (currentPage === totalPages ? ' disabled' : '');
        nextBtn.innerHTML = '<i class="ci-pazar-small ci-caret-right"></i>';
        nextBtn.href = currentPage < totalPages ? getPageUrl(currentPage + 1) : "#";
        nextBtn.setAttribute('page-no', currentPage < totalPages ? currentPage + 1 : "");
        container.appendChild(nextBtn);
    }

    function createPageButton(pageNum) {
        const btn = document.createElement('a');
        btn.className = 'page-number' + (pageNum === pagination.currentPage ? ' active' : '');
        btn.textContent = pageNum;
        btn.setAttribute('page-no', pageNum);
        btn.href = getPageUrl(pageNum);
        container.appendChild(btn);
        return btn;
    }

    function createEllipsis() {
        const ellipsis = document.createElement('div');
        ellipsis.className = 'divider';
        ellipsis.textContent = '...';
        return ellipsis;
    }

    // Initialize
    updateRangeText();
    buildPagination();
    container.classList.remove('hidden');

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            updateRangeText();
            buildPagination();
        }, 150);
    });
};

document.addEventListener("DOMContentLoaded", setupPagination);


function btnCloseSubscriptionListingBanner(e) {
    var newDate = new Date().toDateString();
    $('.vip-services-user-banner').removeClass("show");
    $('.vip-services-user-banner').addClass("hidden");
    setCookie(cookieName, newDate, 7);
}

$(document).ready(function () {

    //--- Save search ---
    try {
        $(document).on('click', '.save-search', function () {
            var url = window.pzListing.saveSearchUrl;
            var query = $('#SearchForm').serialize();
            query += '&isNew=true&PathName=' + window.location.pathname;
            $.ajax({
                url: url,
                type: "GET",
                data: query,
                timeout: 1000 * 50
            })
            .done(function (data) {
                if (data != null && data != undefined && data.Url != undefined && data.Url != '') {
                    window.location.replace(data.Url);
                }
                else if (data != undefined && data != null && data.redirectTo != null) {
                    var ret = data.redirectTo.split('returnUrl');
                    window.location = ret[0] + "returnUrl=" + window.location.pathname;
                }
            })
            .fail(function (data) {});
        });
    } catch (e) {}

    //--- Save / unsave ad ---
    try {
        $(document).on('click', '.img-to-save', function () {
            var url     = window.pzListing.saveAdUrl;
            var obj     = this;
            var isSaved = $(this).hasClass('img-saved');
            var adID    = $(this).data('adid');
            var data    = { 'adId': adID, 'isAdSaved': !isSaved };

            $.ajax({
                url: url,
                type: "GET",
                data: data,
                timeout: 1000 * 50
            })
            .done(function (data) {
                if (data == 'true') {
                    if (isSaved) {
                        $(obj).removeClass('img-saved');
                        $(obj).attr('title', window.pzListing.saveAdText);
                        $('.btn-save-ad[data-id="' + adID + '"]').removeClass('active');
                    } else {
                        $(obj).addClass('img-saved');
                        $(obj).attr('title', window.pzListing.unsaveAdText);
                        $('.btn-save-ad[data-id="' + adID + '"]').addClass('active');
                    }
                }
                else if (data != undefined && data != null && data.redirectTo != null) {
                    var ret = data.redirectTo.split('returnUrl');
                    window.location = ret[0] + "returnUrl=" + window.location.pathname;
                }
            })
            .fail(function (data) {});
        });
    } catch (e) {}
});

window.setupPagination = setupPagination;
window.btnCloseSubscriptionListingBanner = btnCloseSubscriptionListingBanner;
